import React from "react";
import { Modal } from "antd";
import { svg } from "../../../../Assets/svg";

const ViewPricesheetVariableModal: React.FC<{
  visible: boolean;
  data: any;
  onClose:any
}> = ({ visible, data ,onClose}) => {
  

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          {data?.input_title || "Variable Information"}
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"35rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      }
      className="custom-modal"
    >
      <div
        className="d-flex align-items-center justify-content-center gap-2 text-center"
        style={{ whiteSpace: "pre-wrap" }}
      >
        {data?.description || "No description provided."}
      </div>
    </Modal>
  );
};

export default ViewPricesheetVariableModal;
